// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3-EF_","title":"BackImages_title__2_O_5","images":"BackImages_images__2kHCQ"};